import React from 'react';
import ContactFormAccordionGroup from '../../components/ContactFormWidget/ContactFormAccordionGroup';
import ContactFormWidget from '../../components/ContactFormWidget/ContactFormWidget';
import FooterComp from '../../components/Footer/Footer';
import HeaderComp from '../../components/Header/Header';
import NexersysLocationWidget from '../../components/NexersysLocationWidget/NexersysLocationWidget';
import config from '../../config/config';
import { Col, Container, Row } from 'react-bootstrap';
import SetHeaders from '../../config/SetHeaders';
import seo from '../../config/seo';
import Head from 'next/head';
import axios from 'axios';

const ContactFormContainer = ({ Header, Body, Footer, response, history }: any) => {

  const components = (typeName: any, compData: any, key: number) => {
    switch (typeName) {
      case 'connect.page-heading-widget':
        return <ContactFormWidget data={compData} key={key} />;
      case 'connect.form-widget-wrapper':
        return (
          <Container key={key}>
            <Row lg={2} sm={1} xs={1}>
              {compData.FormWidgets &&
                compData.FormWidgets.map((item: any, i: number) => {
                  return (
                    <Col key={i}>
                      <ContactFormAccordionGroup data={item} history={history} />
                    </Col>
                  );
                })}
            </Row>
          </Container>
        );
      case 'page.address-widget':
        return <NexersysLocationWidget data={compData} key={key} />;
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      {response && !response.Seo && (
        <Head>
          <title>{seo.connect}</title>
        </Head>
      )}
      {response && <SetHeaders HEADERS={response} />}
      {Header && <HeaderComp HeaderValue={Header} history={history} />}
      <div className="app-body">
        {Body &&
          Body.map((data: any, i: number) => {
            return components(data.__component, data, i);
          })}
      </div>
      { }
      {Footer && <FooterComp data={Footer} />}
    </React.Fragment>
  );
};

export async function getStaticProps() {
  const { data } = await axios.get(config.endpoints.connect)
  return {
    props: {
      Header: data.Header,
      Body: data.Body,
      Footer: data.Footer.Footer,
      response: data
    },
    revalidate: 3600
  }
}

export default ContactFormContainer
